import {register, CloudObject, defineProperty} from 'olympe';

/**
 * @extends {CloudObject}
 */
export default class AdminChangeLog extends CloudObject {

}

// Hardcoded tags
register('018fc847a597bfc90e81', AdminChangeLog);
AdminChangeLog.dateProp = defineProperty('018fc8834bc1dd88f814');
AdminChangeLog.userIDProp = defineProperty('018fc883249f592ae975');
AdminChangeLog.userNameProp = defineProperty('018fc881f5b3110ce1bd');
AdminChangeLog.tableNameProp = defineProperty('018fc8823caca2997715');
AdminChangeLog.columnProp = defineProperty('018fc8824e3bbc123563');
AdminChangeLog.oldValueProp = defineProperty('018fc88212b30e248814');
AdminChangeLog.newValueProp = defineProperty('018fc8822abad7e12668');
AdminChangeLog.idxProp = defineProperty('01900100f11829de8fc8');
AdminChangeLog.companyCodeProp = defineProperty('0190010131df8431f9c3');
